import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

// Speed test debug block container
export const SpeedTestContainer = styled(Box)({
  position: 'absolute',
  padding: '8px',
  bottom: '0px',
  left: '50px',
  zIndex: 10000,
  color: 'black',
  background: 'white',
  opacity: 0.5,
});

// Speed test metric block
export const MetricBlock = styled(Box)({
  border: '1px solid black',
  padding: '8px',
});

// Speed test metric block (red variant)
export const TestMetricBlock = styled(Box)({
  border: '1px solid red',
  padding: '8px',
});

// Metric label
export const MetricLabel = styled('strong')({
  width: '60px',
  display: 'inline-block',
});

// Expired Link Screen Container
export const ExpiredLinkContainer = styled(Box)({
  minHeight: '100vh',
  width: '100%',
  backgroundColor: '#fff',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '0 16px',
  textAlign: 'center',
});

// Expired Link Emoji
export const ExpiredEmoji = styled(Typography)({
  fontSize: '64px',
  marginBottom: '16px',
  '@media (min-width: 600px)': {
    fontSize: '80px',
    marginBottom: '24px',
  },
});

// Expired Link Title
export const ExpiredTitle = styled(Typography)({
  fontWeight: 700,
  color: '#333',
  marginBottom: '16px',
  fontSize: '1.9rem',
  '@media (min-width: 600px)': {
    fontSize: '2.2rem',
    marginBottom: '24px',
  },
});

// Expired Link Description
export const ExpiredDescription = styled(Typography)({
  color: '#555',
  fontSize: '1rem',
  maxWidth: '460px',
  lineHeight: 1.6,
  '@media (min-width: 600px)': {
    fontSize: '1.125rem',
  },
});

